import {ContactType} from "../../../libs/enum/contact-type";

export class StatisticTopInvoiceContactDto {

  public contactId!: string; // UUID
  public contactType!: ContactType;
  public contactNumber!: string;
  public contactFullName!: string;
  public currencyCode!: string; // Enum: AccCurrency
  public invoiceCount!: number;
  public sumTotalNetAmount!: number;
  public minTotalNetAmount!: number;
  public maxTotalNetAmount!: number;
  public avgTotalNetAmount!: number;
  public discountCount!: number;
  public discountSumNetAmount: number | undefined;
  public discountMinNetAmount: number | undefined;
  public discountMaxNetAmount: number | undefined;
  public discountAvgNetAmount: number | undefined;

  constructor(init?: Partial<StatisticTopInvoiceContactDto> | undefined) {
    Object.assign(this, init);
  }
}
